import React from 'react'
import PropTypes from 'prop-types'
import CollapsedText from '../CollapsedText'
import Gallery from '../Gallery'
import NoIndex from '../NoIndex'

import styles from './material.module.scss'

function ProductMaterial(props) {
  const {
    title,
    content: { description, images },
    seo,
    withoutTitle,
  } = props

  return (
    <NoIndex>
      <div className={styles.root}>
        {!withoutTitle && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.text}>
          <CollapsedText html={seo.description || description} maxCount={200} />
        </div>
        {images && images.length && (
          <div className={styles.images}>
            <Gallery items={images} />
          </div>
        )}
      </div>
    </NoIndex>
  )
}

ProductMaterial.propTypes = {
  title: PropTypes.string,
  content: PropTypes.shape({
    description: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.object),
  }),
  seo: PropTypes.object,
  withoutTitle: PropTypes.bool,
}

export default ProductMaterial
